/**
 * Build-time feature flags.
 *
 * Read from the environment at build time, not runtime -- CRA inlines
 * REACT_APP_* into the bundle, so flipping one means a rebuild and redeploy.
 */

/**
 * The AI Stock Scanner.
 *
 * Off unless explicitly enabled. It calls OpenAI from POST /api/scan/analyze
 * and returns a 500 when OPENAI_API_KEY is unset, so with the flag off a shop
 * without a key cannot reach a dead button -- and one with a key does not pay
 * per scan until someone decides the feature is wanted.
 *
 * Enable with REACT_APP_ENABLE_SCANNER=true at build time, and set
 * OPENAI_API_KEY on the API before doing so.
 */
export const SCANNER_ENABLED = process.env.REACT_APP_ENABLE_SCANNER === "true";
